import { Route } from 'src/routes/Route'

export const UnlockVerifyCodeRoute = Route({
  path: '/verify-code',
  init: () => ({}),
  fromPath: () => ({}),
})
export type UnlockVerifyCodeRoute = Route<typeof UnlockVerifyCodeRoute>
